export enum ApplianceDetailsModelSerialFormField {
  ModelNumber = 'modelNumber',
  SerialNumber = 'serialNumber',
}
